/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_DeletedInputs */

const en_admin_posts_deleted = /** @type {(inputs: Admin_Posts_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post deleted`)
};

/**
* | output |
* | --- |
* | "Post deleted" |
*
* @param {Admin_Posts_DeletedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_deleted = /** @type {((inputs?: Admin_Posts_DeletedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_DeletedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_deleted(inputs)
});
export { admin_posts_deleted as "admin.posts.deleted" }